import { createReducerFromMap } from "@coverme/redux";
import { cloneDeep } from "lodash-es";
import { insuranceCompanyTypes } from "../../components/FormComponents/CoveragePrivateSelect";
import { isNullOrWhitespace } from "../../services/stringService";

const initialState = {
    hasCoverage: undefined,
    primaryCoverage: {
        typeOfCoverage: undefined,
        companyName: "",
        companyNameOther: "",
        memberNumber: "",
        isSsiSSdCasePending: undefined,
        caseAttorneyName: "",
        caseAttorneyPhone: "",
        startDate: "",
    },
    hasSupplementalCoverage: undefined,
    supplementalCoverage: {
        typeOfCoverage: undefined,
        companyName: "",
        companyNameOther: "",
        memberNumber: "",
        isSsiSSdCasePending: undefined,
        caseAttorneyName: "",
        caseAttorneyPhone: "",
        startDate: "",
    },
    hasFullCoverage: undefined,
    coverageSummary: undefined,
    isFullyCovered: false,
    hasCoverageBeenChecked: false,
    shouldContinue: undefined,
    isCoverageSummaryLoading: undefined,
    isSeekingMedicalServicesDueToAccidentOrCrime: undefined,
    thirdPartyLiability: {
        typeOfAccident: "",
        policyNumber: "",
        contactName: "",
        phoneNumber: "",
        workCompCarrier: "",
        employerContactName: "",
        employerName: "",
        additionalNotes: "",
        homeownerCompany: "",
        medPayCoverage: "",
        liabilityLimits: "",
    },
};

function updateCoverage(state, data) {
    const newCoverage = {
        ...state,
        ...cloneDeep(data.value),
    };

    const insuranceCompanyTypeStrings = insuranceCompanyTypes.map(x => x.value);
    const prepareCoverage = individualCoverage => {
        if (individualCoverage == null) {
            return initialState.primaryCoverage;
        } else {
            const hasCompanyName =
                insuranceCompanyTypeStrings.includes(individualCoverage.companyName) &&
                isNullOrWhitespace(individualCoverage.companyName);
            let result = {
                ...individualCoverage,
            };
            if (hasCompanyName) {
                result = {
                    ...result,
                    companyName: hasCompanyName ? individualCoverage.companyName : "Other",
                    companyNameOther: hasCompanyName ? null : individualCoverage.companyName,
                };
            }

            return result;
        }
    };

    newCoverage.primaryCoverage = prepareCoverage(newCoverage.primaryCoverage);
    newCoverage.supplementalCoverage = prepareCoverage(newCoverage.supplementalCoverage);

    // Added through quick entry.
    if (newCoverage.hasCoverage === true && newCoverage.primaryCoverage === initialState.primaryCoverage) {
        newCoverage.hasSupplementalCoverage = undefined;
    }

    return newCoverage;
}

function deletePersonCoverage(state, action) {
    let coverageSection = { ...state };
    // as this operation only happens when coverageSource is Interview and only 1 is allowed, clears the arrat
    coverageSection.coverageSummary = [];
    return coverageSection;
}

function setCoverageSummaryLoading(state, action) {
    return {
        ...state,
        isCoverageSummaryLoading: true,
    };
}

function updateCoverageSummary(state, action) {
    return {
        ...state,
        coverageSummary: action.value,
        isCoverageSummaryLoading: false,
    };
}

function updateCoverageStatus(state, action) {
    let coverageSection = { ...state };
    coverageSection.hasCoverageBeenChecked = action.value;
    return coverageSection;
}

function updateIsFullyCovered(state, action) {
    let coverageSection = { ...state };
    coverageSection.isFullyCovered = action.value;
    return coverageSection;
}

function setPersonCoverage(state, action) {
    let interviewToUpdate = { ...state };
    // clears the previous coverage and set the new one
    interviewToUpdate.coverageSummary.personCoverages = [];
    interviewToUpdate.coverageSummary.personCoverages = action.value;
    return interviewToUpdate;
}

function updatePersonCoverage(state, action) {
    let interviewToUpdate = { ...state };
    // clears the previous coverage and set the new one
    interviewToUpdate.coverageSummary.personCoverages.push(action.value);
    return interviewToUpdate;
}

function setContinueAfterCoverage(state, action) {
    return {
        ...state,
        shouldContinue: action.value,
    };
}

function getInterview(state, action) {
    if (action.value.coverage) {
        const newState = updateCoverage(state, { value: action.value.coverage });
        newState.coverageSummary = action.value.coverage.coverageSummary;
        return newState;
    }

    return state;
}

function deleteManualPersonCoverage(state, action) {
    const newState = {
        ...state,
    };

    if (state.coverageSummary == null) {
        return newState;
    }

    const personCoverages = state.coverageSummary?.personCoverages?.filter(
        x =>
            x.coverageSource.name !== action.value.coverageSource.name &&
            x.healthInsuranceType.name !== action.value.healthInsuranceType.name
    );

    let newCoverageSummary = state.coverageSummary;
    newCoverageSummary.personCoverages = personCoverages;

    return {
        ...newState,
        coverageSummary: newCoverageSummary,
    };
}

function resetInterview(state, action) {
    return initialState;
}

function cancelCoverageDiscovery(state) {
    return {
        ...state,
        isCoverageSummaryLoading: false,
    };
}

export const coverageReducer = createReducerFromMap(initialState, {
    UPDATE_COVERAGE_COMPLETE: updateCoverage,
    GET_COVERAGE_SUMMARY_START: setCoverageSummaryLoading,
    GET_COVERAGE_SUMMARY_COMPLETE: updateCoverageSummary,
    GET_COVERAGE_VERIFICATION_START: setCoverageSummaryLoading,
    GET_COVERAGE_VERIFICATION_COMPLETE: updateCoverageSummary,
    GET_COVERAGE_DISCOVERY_START: setCoverageSummaryLoading,
    GET_COVERAGE_DISCOVERY_COMPLETE: updateCoverageSummary,
    UPDATE_COVERAGE_STATUS: updateCoverageStatus,
    GET_IS_FULLY_COVERED_COMPLETE: updateIsFullyCovered,
    SET_PERSON_COVERAGE_COMPLETE: setPersonCoverage,
    UPDATE_PERSON_COVERAGE_COMPLETE: updatePersonCoverage,
    DELETE_PERSON_COVERAGE_COMPLETE: deletePersonCoverage,
    SET_CONTINUE_AFTER_COVERAGE: setContinueAfterCoverage,
    DELETE_MANUAL_PERSON_COVERAGE_COMPLETE: deleteManualPersonCoverage,
    RESET_INTERVIEW: resetInterview,
    GET_INTERVIEW_COMPLETE: getInterview,
    CANCEL_COVERAGE_DISCOVERY: cancelCoverageDiscovery,
});
